import { Card, CardContent, Skeleton } from '@mui/material';
import { Box } from '@mui/system';

const ProductCardSkeleton = () => (
  <Card
    sx={{
      backgroundColor: 'background.default',
      color: 'white',
      borderRadius: 2,
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      overflow: 'hidden',
    }}
  >
    <Skeleton variant="rectangular" width="100%" height={0} sx={{ paddingTop: '100%' }} />
    <CardContent sx={{ padding: 2, flex: 1, display: 'flex', flexDirection: 'column' }}>
      <Box display="flex" justifyContent="space-between" alignItems="start">
        <Box sx={{ overflow: 'hidden', maxWidth: '75%' }}>
          <Skeleton variant="text" width="80%" height={28} sx={{ mb: 1 }} />
        </Box>
        <Skeleton variant="text" width={40} height={24} />
      </Box>

      <Skeleton variant="text" width="40%" height={20} sx={{ mt: 1 }} />
      <Skeleton variant="text" width="60%" height={32} sx={{ mt: 0.5 }} />

      <Box sx={{ my: 1 }}>
        <Skeleton variant="rectangular" width="100%" height={1} />
      </Box>

      <Box display="flex" flexWrap="wrap" gap={0.5}>
        <Skeleton variant="text" width={80} height={20} />
        <Skeleton variant="text" width={60} height={20} />
        <Skeleton variant="text" width={100} height={20} />
      </Box>
    </CardContent>
  </Card>
);

export default ProductCardSkeleton;
